export default __webpack_public_path__ + "static/media/audio_44_guitarra.57fb110f.mp3";